import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Lock, ArrowLeft } from "lucide-react";

/**
 * Self-registration is temporarily disabled.
 * The backend enforces this via the REGISTRATIONS_OPEN env var, so even a
 * direct API call is rejected. This page simply mirrors that state with a
 * clear message matching the existing Login layout.
 */
export default function Register() {
  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="register-closed-page">
      {/* Left: message */}
      <div className="flex items-center justify-center p-8 lg:p-16 bg-[#FAFAFA]">
        <div className="w-full max-w-md animate-fade-up">
          <Link to="/login" className="flex items-center gap-3 mb-16 w-fit">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#C5A059] to-[#B38F4E] flex items-center justify-center">
              <Sparkles className="w-5 h-5 text-white" strokeWidth={2} />
            </div>
            <div className="flex flex-col leading-none">
              <span className="font-serif-display text-2xl text-[#1A1A1A]">AI TricoProtocol</span>
              <span className="text-[10px] tracking-[0.25em] text-[#C5A059] uppercase mt-1">
                Professional Edition
              </span>
            </div>
          </Link>

          <div className="w-14 h-14 rounded-2xl bg-[#FAF6EE] flex items-center justify-center mb-6">
            <Lock className="w-7 h-7 text-[#C5A059]" />
          </div>

          <h1 className="font-serif-display text-4xl sm:text-5xl text-[#1A1A1A] mb-3 gold-underline inline-block">
            Registrazioni chiuse
          </h1>
          <p className="text-[#737373] leading-relaxed mt-6 mb-10" data-testid="register-closed-message">
            Registrazioni temporaneamente chiuse. Il servizio sarà presto disponibile.
          </p>

          <div className="space-y-4">
            <Link
              to="/login"
              className="w-full h-12 rounded-xl bg-[#1A1A1A] text-white font-medium hover:bg-[#C5A059] transition-all duration-300 inline-flex items-center justify-center gap-2"
              data-testid="register-closed-login-btn"
            >
              <ArrowLeft className="w-4 h-4" />
              Torna al login
            </Link>

            <p className="text-sm text-[#737373]">
              Sei già cliente? Accedi con le tue credenziali o{" "}
              <a
                href="mailto:supporto@aitricoprotocol.com"
                className="text-[#C5A059] hover:underline font-medium"
                data-testid="register-closed-support-link"
              >
                contatta il supporto
              </a>
              .
            </p>
          </div>
        </div>
      </div>

      {/* Right: same visual as login */}
      <div
        className="hidden lg:block relative bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://customer-assets.emergentagent.com/job_hair-protocol-1/artifacts/8av7aywi_4515BF52-8647-4F43-91E5-A5C622E65361.PNG')",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#1A1A1A]/75 via-[#1A1A1A]/45 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12 animate-fade-up">
          <p
            className="text-xs font-medium uppercase mb-4 text-[#666666] opacity-80"
            style={{ letterSpacing: "0.08em" }}
          >
            Accesso riservato
          </p>
          <h2
            className="font-serif-display text-4xl xl:text-5xl leading-tight font-semibold text-[#111111]"
            style={{ textShadow: "0px 1px 2px rgba(0,0,0,0.15)" }}
          >
            Apertura nuove iscrizioni<br />
            <span className="italic text-[#333333]">in arrivo.</span>
          </h2>
          <p className="mt-6 text-sm text-[#555555] max-w-md">
            Per richiedere l&apos;attivazione anticipata scrivi a supporto@aitricoprotocol.com.
          </p>
        </div>
      </div>
    </div>
  );
}
